import React from "react";
import { KIcon } from "@kyburz/kdesign-system";
import { ScheduledUpdatesColumns } from "./types";

type ColumnsParams = {
  classes: { iconContainer: string };
  toggleSchedulePopup: (scheduledUpdate: any) => void;
  onDeleteClick: (row: { id: string; updateType: string }) => void;
};

const COLUMN_WIDTH = 250;

export const getColumns = ({
  classes,
  toggleSchedulePopup,
  onDeleteClick,
}: ColumnsParams) => [
  {
    Header: "ID",
    accessor: ScheduledUpdatesColumns.ID,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
    sticky: "left",
  },
  {
    Header: "Update Type",
    accessor: ScheduledUpdatesColumns.UpdateType,
    Cell: (row) => (
      <div style={{ textAlign: "center" }}>
        <span>{row.row.original.updateType}</span>
      </div>
    ),
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Created",
    accessor: ScheduledUpdatesColumns.Created,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Modified",
    accessor: ScheduledUpdatesColumns.Modified,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Device Firmware ID",
    accessor: ScheduledUpdatesColumns.DeviceFirmwareID,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Allowed From",
    accessor: ScheduledUpdatesColumns.AllowedFromStr,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Allowed To",
    accessor: ScheduledUpdatesColumns.AllowedToStr,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Only Ignition On",
    accessor: ScheduledUpdatesColumns.OnlyIgnitionOn,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Only Ignition Off",
    accessor: ScheduledUpdatesColumns.OnlyIgnitionOff,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Imeis",
    accessor: ScheduledUpdatesColumns.ImeisStr,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Created By",
    accessor: ScheduledUpdatesColumns.CreatedBy,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Status",
    accessor: ScheduledUpdatesColumns.Status,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Execute Job ID",
    accessor: ScheduledUpdatesColumns.ExecuteJobID,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Expire Job ID",
    accessor: ScheduledUpdatesColumns.ExpireJobID,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "History",
    accessor: ScheduledUpdatesColumns.HistoryStr,
    width: COLUMN_WIDTH,
    defaultCanSort: true,
  },
  {
    Header: "Actions",
    Cell: (row) => (
      <div style={{ textAlign: "center" }}>
        <div
          className={classes.iconContainer}
          style={{ marginRight: "16px" }}
          onClick={() => toggleSchedulePopup(row.row.original)}
        >
          <KIcon icon="edit" color="#383F51" size={20} />
        </div>
        <div
          className={classes.iconContainer}
          onClick={() => onDeleteClick(row.row.original)}
        >
          <KIcon icon="trash-2" color="#383F51" size={20} />
        </div>
      </div>
    ),
    width: 100,
    sticky: "right",
  },
];